import { render, staticRenderFns } from "./edit_gift_wrap.vue?vue&type=template&id=c5dd039c&"
import script from "./edit_gift_wrap.vue?vue&type=script&lang=js&"
export * from "./edit_gift_wrap.vue?vue&type=script&lang=js&"
import style0 from "./edit_gift_wrap.vue?vue&type=style&index=0&id=c5dd039c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports